<script>
	import { getContext, onDestroy } from 'svelte'
	import { url } from '../../library/scripts/Setup.svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import {
		storeElementID,
		storeData,
		storeSelectedIcon,
		storeImageTemplate,
		storeImageModal,
	} from '../../library/scripts/Store.svelte'
	import { get_element_tags, get_initial_values, create_image_template } from '../builderUtils'
	import ColorSelector from '../ColorSelector.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../modals/Alert.svelte'
	import ImageModal from '../ImageModal.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	const mainTool = globals.mainTool
	const mainToolHover = globals.mainToolHover
	const subTool = globals.subTool
	const subToolHover = globals.subToolHover

	let elementID
	let config
	let blocks
	let blockID, columnID, elementTag

	//show hide tool
	let generalTool
	let showTool1
	let showTool2
	let showTool3

	// error for checkbox if column has link
	let error = false

	//the selectedIcon from store
	let selectedStoreIcon

	//the values to send to sizeSelectors
	let selectedBorderWidth

	//css selections
	let selectedImage,
		selectedWidth,
		selectedSX,
		selectedSY,
		selectedSBlur,
		selectedSColor = 'hsla(0,0%,0%,0)',
		selectedBorderColor = 'hsla(0,0%,0%,1)',
		selectedOpac,
		selectedBLwidth,
		selectedBLcolor,
		selectedBTwidth,
		selectedBTcolor,
		selectedBRwidth,
		selectedBRcolor,
		selectedBBwidth,
		selectedBBcolor,
		selectedMarginTop,
		selectedMarginBottom,
		selectedPadding,
		selectedBTradius,
		selectedBBradius

	//icon selected
	let selectedIcon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor

	//stative ID for getElementById in SelectValues
	const idColor1 = '1'
	const idColor2 = '2'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idBorderWidth = '6'
	const idBTradius = '42'
	const idBBradius = '17'
	const idImageSize = '13'
	const idShadowX = '14'
	const idShadowY = '15'
	const idShadowBlur = '16'

	//show border tools
	let iconSelected = false

	//preview image
	let prevImage
	let origImage
	let imagePath
	let showImgModal

	//background image
	let setBackground = false
	//background color of column
	let colBG

	//template
	let template

	const stoImageModal = storeImageModal.subscribe((value) => {
		showImgModal = value
	})
	const stoTemplate = storeImageTemplate.subscribe((value) => {
		template = value
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the initial css values from config.json
	$: if (elementID.indexOf('image') > -1) {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		selectedImage = values[0]
		selectedWidth = values[1]
		selectedSX = values[2]
		selectedSY = values[3]
		selectedSBlur = values[4]
		selectedSColor = values[5]
		selectedOpac = values[6]
		selectedBLwidth = values[7]
		selectedBLcolor = values[8]
		selectedBTwidth = values[9]
		selectedBTcolor = values[10]
		selectedBRwidth = values[11]
		selectedBRcolor = values[12]
		selectedBBwidth = values[13]
		selectedBBcolor = values[14]
		selectedMarginTop = values[15]
		selectedMarginBottom = values[16]
		selectedPadding = values[17]
		selectedBTradius = values[18]
		selectedBBradius = values[19]
		colBG = values[20]

		if (selectedBLwidth > 0) {
			icon1 = true
			set_icon_color('left')
		}
		if (selectedBTwidth > 0) {
			icon2 = true
			set_icon_color('top')
		}

		if (selectedBRwidth > 0) {
			icon3 = true
			set_icon_color('right')
		}

		if (selectedBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom')
		}

		if (selectedBLwidth > 0 && selectedBTwidth > 0 && selectedBRwidth > 0 && selectedBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all')
		}
		prevImage = url + '/' + blockID + '/thumbnail/' + selectedImage
		origImage = url + '/'  + blockID + '/large/' + selectedImage
		imagePath = '../'  + blockID + '/large/' + selectedImage
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedBLwidth

	// background image
	$: if (setBackground) set_background_image()
	$: if (!setBackground) remove_background_image()

	const set_icon_color = (c) => {
		if (c === 'left') icon1Color = iconHover
		if (c === 'top') icon2Color = iconHover
		if (c === 'right') icon3Color = iconHover
		if (c === 'bottom') icon4Color = iconHover
		if (c === 'all') {
			icon1Color = iconHover
			icon2Color = iconHover
			icon3Color = iconHover
			icon4Color = iconHover
			icon5Color = iconHover
		}
		if (c === 'none') {
			icon1Color = iconColor
			icon2Color = iconColor
			icon3Color = iconColor
			icon4Color = iconColor
			icon5Color = iconColor
		}
	}

	const reset_error = () => {
		error = false
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'imgSize') {
					if (blockID !== 'gallery') block.content[columnID - 1].imageWidth = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imageWidth = cssTag
				}

				if (cmd === 'sC') {
					if (blockID !== 'gallery') {
						block.content[columnID - 1].boxShadowX = '5'
						block.content[columnID - 1].boxShadowY = '5'
						block.content[columnID - 1].boxShadowBlur = '2'
						block.content[columnID - 1].boxShadowColor = cssTag
					}

					if (blockID === 'gallery') {
						block.content[(block.content.length - 1) / 2].boxShadowX = '5'
						block.content[(block.content.length - 1) / 2].boxShadowY = '5'
						block.content[(block.content.length - 1) / 2].boxShadowBlur = '2'
						block.content[(block.content.length - 1) / 2].boxShadowColor = cssTag
					}
				}

				if (cmd == 'sB') {
					if (blockID !== 'gallery') block.content[columnID - 1].boxShadowBlur = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].boxShadowBlur = cssTag
				}

				if (cmd == 'sX') {
					if (blockID !== 'gallery') block.content[columnID - 1].boxShadowX = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].boxShadowX = cssTag
				}

				if (cmd == 'sY') {
					if (blockID !== 'gallery') block.content[columnID - 1].boxShadowY = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].boxShadowY = cssTag
				}

				if (cmd === 'bL') {
					if (blockID !== 'gallery') {
						if (icon1 && selectedIcon === 'icon1') {
							block.content[columnID - 1].imageBorderLeftColor = cssTag
							block.content[columnID - 1].imageBorderLeftWidth = '1'
							icon1Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[columnID - 1].imageBorderLeftWidth = '0'
							icon1Color = iconColor
							icon5Color = iconColor
						}
					}

					if (blockID === 'gallery') {
						if (icon1 && selectedIcon === 'icon1') {
							block.content[(block.content.length - 1) / 2].imageBorderLeftColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = '1'
							icon1Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = '0'
							icon1Color = iconColor
							icon5Color = iconColor
						}
					}
				}

				if (cmd === 'bT') {
					if (blockID !== 'gallery') {
						if (icon2 && selectedIcon === 'icon2') {
							block.content[columnID - 1].imageBorderTopColor = cssTag
							block.content[columnID - 1].imageBorderTopWidth = '1'
							icon2Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[columnID - 1].imageBorderTopWidth = '0'
							icon2Color = iconColor
							icon5Color = iconColor
						}
					}

					if (blockID === 'gallery') {
						if (icon2 && selectedIcon === 'icon2') {
							block.content[(block.content.length - 1) / 2].imageBorderTopColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = '1'
							icon2Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = '0'
							icon2Color = iconColor
							icon5Color = iconColor
						}
					}
				}

				if (cmd === 'bR') {
					if (blockID !== 'gallery') {
						if (icon3 && selectedIcon === 'icon3') {
							block.content[columnID - 1].imageBorderRightColor = cssTag
							block.content[columnID - 1].imageBorderRightWidth = '1'
							icon3Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[columnID - 1].imageBorderRightWidth = '0'
							icon3Color = iconColor
							icon5Color = iconColor
						}
					}

					if (blockID === 'gallery') {
						if (icon3 && selectedIcon === 'icon3') {
							block.content[(block.content.length - 1) / 2].imageBorderRightColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = '1'
							icon3Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = '0'
							icon3Color = iconColor
							icon5Color = iconColor
						}
					}
				}

				if (cmd === 'bB') {
					if (blockID !== 'gallery') {
						if (icon4 && selectedIcon === 'icon4') {
							block.content[columnID - 1].imageBorderBottomColor = cssTag
							block.content[columnID - 1].imageBorderBottomWidth = '1'
							icon4Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[columnID - 1].imageBorderBottomWidth = '0'
							icon4Color = iconColor
							icon5Color = iconColor
						}
					}

					if (blockID === 'gallery') {
						if (icon4 && selectedIcon === 'icon4') {
							block.content[(block.content.length - 1) / 2].imageBorderBottomColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = '1'
							icon4Color = iconHover
							if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
						} else {
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = '0'
							icon4Color = iconColor
							icon5Color = iconColor
						}
					}
				}

				if (cmd === 'bA') {
					if (blockID !== 'gallery') {
						if (icon5 && selectedIcon === 'icon5') {
							block.content[columnID - 1].imageBorderLeftColor = cssTag
							block.content[columnID - 1].imageBorderLeftWidth = '1'
							block.content[columnID - 1].imageBorderTopColor = cssTag
							block.content[columnID - 1].imageBorderTopWidth = '1'
							block.content[columnID - 1].imageBorderRightColor = cssTag
							block.content[columnID - 1].imageBorderRightWidth = '1'
							block.content[columnID - 1].imageBorderBottomColor = cssTag
							block.content[columnID - 1].imageBorderBottomWidth = '1'
							icon5Color = iconHover
							icon1Color = iconHover
							icon2Color = iconHover
							icon3Color = iconHover
							icon4Color = iconHover
						} else {
							block.content[columnID - 1].imageBorderLeftWidth = '0'
							block.content[columnID - 1].imageBorderTopWidth = '0'
							block.content[columnID - 1].imageBorderRightWidth = '0'
							block.content[columnID - 1].imageBorderBottomWidth = '0'
							icon5Color = iconColor
							icon1Color = iconColor
							icon2Color = iconColor
							icon3Color = iconColor
							icon4Color = iconColor
							icon1 = false
							icon2 = false
							icon3 = false
							icon4 = false
							icon5 = false
						}
					}

					if (blockID === 'gallery') {
						if (icon5 && selectedIcon === 'icon5') {
							block.content[(block.content.length - 1) / 2].imageBorderLeftColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = '1'
							block.content[(block.content.length - 1) / 2].imageBorderTopColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = '1'
							block.content[(block.content.length - 1) / 2].imageBorderRightColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = '1'
							block.content[(block.content.length - 1) / 2].imageBorderBottomColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = '1'
							icon5Color = iconHover
							icon1Color = iconHover
							icon2Color = iconHover
							icon3Color = iconHover
							icon4Color = iconHover
						} else {
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = '0'
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = '0'
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = '0'
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = '0'
							icon5Color = iconColor
							icon1Color = iconColor
							icon2Color = iconColor
							icon3Color = iconColor
							icon4Color = iconColor
							icon1 = false
							icon2 = false
							icon3 = false
							icon4 = false
							icon5 = false
						}
					}
				}

				if (cmd === 'bWidth') {
					if (blockID !== 'gallery') {
						if (icon1 && selectedIcon === 'icon1') block.content[columnID - 1].imageBorderLeftWidth = cssTag
						if (icon2 && selectedIcon === 'icon2') block.content[columnID - 1].imageBorderTopWidth = cssTag
						if (icon3 && selectedIcon === 'icon3') block.content[columnID - 1].imageBorderRightWidth = cssTag
						if (icon4 && selectedIcon === 'icon4') block.content[columnID - 1].imageBorderBottomWidth = cssTag
						if (icon5 && selectedIcon === 'icon5') {
							block.content[columnID - 1].imageBorderLeftWidth = cssTag
							block.content[columnID - 1].imageBorderTopWidth = cssTag
							block.content[columnID - 1].imageBorderRightWidth = cssTag
							block.content[columnID - 1].imageBorderBottomWidth = cssTag
						}
					}

					if (blockID === 'gallery') {
						if (icon1 && selectedIcon === 'icon1')
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = cssTag
						if (icon2 && selectedIcon === 'icon2')
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = cssTag
						if (icon3 && selectedIcon === 'icon3')
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = cssTag
						if (icon4 && selectedIcon === 'icon4')
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = cssTag
						if (icon5 && selectedIcon === 'icon5') {
							block.content[(block.content.length - 1) / 2].imageBorderLeftWidth = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderTopWidth = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderRightWidth = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderBottomWidth = cssTag
						}
					}
				}

				if (cmd === 'bColor' || cmd === 'bOpacity') {
					if (blockID !== 'gallery') {
						if (icon1 && selectedIcon === 'icon1') block.content[columnID - 1].imageBorderLeftColor = cssTag
						if (icon2 && selectedIcon === 'icon2') block.content[columnID - 1].imageBorderTopColor = cssTag
						if (icon3 && selectedIcon === 'icon3') block.content[columnID - 1].imageBorderRightColor = cssTag
						if (icon4 && selectedIcon === 'icon4') block.content[columnID - 1].imageBorderBottomColor = cssTag
						if (icon5 && selectedIcon === 'icon5') {
							block.content[columnID - 1].imageBorderLeftColor = cssTag
							block.content[columnID - 1].imageBorderTopColor = cssTag
							block.content[columnID - 1].imageBorderRightColor = cssTag
							block.content[columnID - 1].imageBorderBottomColor = cssTag
						}
					}

					if (blockID === 'gallery') {
						if (icon1 && selectedIcon === 'icon1')
							block.content[(block.content.length - 1) / 2].imageBorderLeftColor = cssTag
						if (icon2 && selectedIcon === 'icon2')
							block.content[(block.content.length - 1) / 2].imageBorderTopColor = cssTag
						if (icon3 && selectedIcon === 'icon3')
							block.content[(block.content.length - 1) / 2].imageBorderRightColor = cssTag
						if (icon4 && selectedIcon === 'icon4')
							block.content[(block.content.length - 1) / 2].imageBorderBottomColor = cssTag
						if (icon5 && selectedIcon === 'icon5') {
							block.content[(block.content.length - 1) / 2].imageBorderLeftColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderTopColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderRightColor = cssTag
							block.content[(block.content.length - 1) / 2].imageBorderBottomColor = cssTag
						}
					}
				}

				if (cmd === 'btRadius') {
					if (blockID !== 'gallery') block.content[columnID - 1].imageBorderTopRadius = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imageBorderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					if (blockID !== 'gallery') block.content[columnID - 1].imageBorderBottomRadius = cssTag
					if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imageBorderBottomRadius = cssTag
				}
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_image_size = (e) => {
		set_css_tag(e.detail.value, 'imgSize')
	}

	const set_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sX')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_shadow_opacity = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_opacity = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_margin_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (blockID !== 'gallery') block.content[columnID - 1].imageMarginTop = value
				if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imageMarginTop = value

				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (blockID !== 'gallery') block.content[columnID - 1].imageMarginBottom = value
				if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imageMarginBottom = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (blockID !== 'gallery') block.content[columnID - 1].imagePadding = value
				if (blockID === 'gallery') block.content[(block.content.length - 1) / 2].imagePadding = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const create_template = () => {
		storeImageTemplate.set([blockID, columnID, elementTag])
	}

	const use_template = async () => {
		const b = blocks
		//seperate the tag to get the tag value without column
		const tag = elementTag.split(' ')[2]
		const temp = await create_image_template(template, blockID, columnID, tag, b)

		config.blocks = temp
		storeData.set(config)
	}

	const alterate_image = () => {
		return
		storeImageModal.set(true)
		showImgModal = true
	}

	const close_modal = () => {
		storeImageModal.set(true)
		
		showImgModal = false
	}

	const set_background_image = () => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (
					block.content[columnID - 1].link &&
					block.content[columnID - 1].link !== 'select' &&
					block.content[columnID - 1].id === 1
				) {
					setBackground = false
					error = true
				}
				if (
					block.content[columnID - 1].link &&
					block.content[columnID - 1].link !== 'select' &&
					block.content[columnID - 1].id === 2
				) {
					setBackground = false
					error = true
				}
				if (
					block.content[columnID - 1].link &&
					block.content[columnID - 1].link !== 'select' &&
					block.content[columnID - 1].id === 3
				) {
					setBackground = false
					error = true
				}
				if (
					block.content[columnID - 1].link &&
					block.content[columnID - 1].link !== 'select' &&
					block.content[columnID - 1].id === 4
				) {
					setBackground = false
					error = true
				}
				if (error) return
				block.content[columnID - 1].backgroundImage = block.content[columnID - 1].image
				block.content[columnID - 1].backgroundColor = 'hsla(0,0%,0%,0)'
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const remove_background_image = () => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].backgroundImage = null
				block.content[columnID - 1].backgroundColor = colBG
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	//timeout (wait until tool3 is loaded)
	let toTool3
	const open_tool = (t) => {
		if (t === 'generalTool') {
			generalTool = generalTool === true ? false : true
			showTool2 = false
			showTool3 = false
			return
		}
		if (t === 1) {
			showTool1 = showTool1 === true ? false : true
			return
		}

		if (t === 2) {
			showTool2 = showTool2 === true ? false : true
			generalTool = false
			showTool3 = false
			return
		}

		if (t === 3) {
			showTool3 = showTool3 === true ? false : true
			generalTool = false
			showTool2 = false
			if (showTool3) {
				if (!icon1) icon1Color = iconColor
				if (!icon2) icon2Color = iconColor
				if (!icon3) icon3Color = iconColor
				if (!icon4) icon4Color = iconColor
				if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor
				toTool3 = setTimeout(() => {
					icon1Color = icon1Color
					icon2Color = icon2Color
					icon3Color = icon3Color
					icon4Color = icon4Color
					icon5Color = icon5Color
				}, 10)
			}
			return
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoTemplate
		stoImageModal
		clearTimeout(toTool3)
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div class="template" use:styles={{ fsXS, iconHover }} on:click={create_template} on:keydown={create_template}>
			Create Template
		</div>
		{#if template}
			<div class="sub_template" use:styles={{ fsXS, iconHover }} on:click={use_template} on:keydown={use_template}>
				Use Template
			</div>
		{/if}
		<div
			class="part_title mainTool"
			on:click={() => open_tool(1)}
			on:keydown={() => open_tool(1)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			IMAGE - CONTAINER
		</div>
		{#if showTool1}
			<div transition:slide={{ duration: 500 }}>
				<div class="preview">
					<img
						id="thumb_{selectedImage}"
						src={prevImage}
						alt="i"
						width="50%"
						on:click={alterate_image}
						on:keydown={alterate_image}
						style="cursor:pointer;"
					/>
				</div>
				{#if blockID !== 'gallery'}
					<div class="set_background" use:styles={{ fsXS }}>
						set as background
						<input id="setbackground" type="checkbox" bind:checked={setBackground} />
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool')}
					on:keydown={() => open_tool('generalTool')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>ImageSize</div>
						<SizeSelector ID={idImageSize} range="100" initialValue={selectedWidth} on:sizechange={set_image_size} />

						<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
						<SizeSelector ID={idMarginTop} range="20" initialValue={selectedMarginTop} on:sizechange={set_margin_top} />

						<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
						<SizeSelector
							ID={idMarginBottom}
							range="20"
							initialValue={selectedMarginBottom}
							on:sizechange={set_margin_bottom}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
						<SizeSelector ID={idPadding} range="15" initialValue={selectedPadding} on:sizechange={set_padding} />
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool(2)}
					on:keydown={() => open_tool(2)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					shadow
				</div>
				{#if showTool2}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>Image Shadow</div>
						<ColorSelector
							on:setcolor={set_shadow_color}
							on:setopacity={set_shadow_opacity}
							ID={idColor1}
							selectedColor={selectedSColor}
							initialValue={selectedOpac}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
						<SizeSelector ID={idShadowX} range="20" unit="px" initialValue={selectedSX} on:sizechange={set_offset_x} />

						<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
						<SizeSelector ID={idShadowY} range="20" unit="px" initialValue={selectedSY} on:sizechange={set_offset_y} />

						<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idShadowBlur}
							range="20"
							unit="px"
							initialValue={selectedSBlur}
							on:sizechange={set_blur}
						/>
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(3)}
					on:keydown={() => open_tool(3)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					border
				</div>
				{#if showTool3}
					<div transition:slide={{ duration: 500 }}>
						<div class="icon_container">
							<div
								id="icon1"
								class="icon icon1"
								use:styles={{ icon, icon1Color, iconHover }}
								on:click={set_icon_1}
								on:keydown={set_icon_1}
							/>
							<div
								id="icon2"
								class="icon icon2"
								use:styles={{ icon, icon2Color, iconHover }}
								on:click={set_icon_2}
								on:keydown={set_icon_2}
							/>
							<div
								id="icon3"
								class="icon icon3"
								use:styles={{ icon, icon3Color, iconHover }}
								on:click={set_icon_3}
								on:keydown={set_icon_3}
							/>
							<div
								id="icon4"
								class="icon icon4"
								use:styles={{ icon, icon4Color, iconHover }}
								on:click={set_icon_4}
								on:keydown={set_icon_4}
							/>
							<div
								id="icon5"
								class="icon icon5"
								use:styles={{ icon, icon5Color, iconHover }}
								on:click={set_icon_5}
								on:keydown={set_icon_5}
							/>
						</div>
						{#if iconSelected}
							<div in:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
								<ColorSelector
									on:setcolor={set_border_color}
									on:setopacity={set_border_opacity}
									ID={idColor2}
									selectedColor={selectedBorderColor}
									initialValue={selectedOpac}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
								<SizeSelector
									ID={idBorderWidth}
									range="50"
									unit="px"
									initialValue={selectedBorderWidth}
									on:sizechange={set_border_width}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Top Radius</div>
								<SizeSelector
									ID={idBTradius}
									range="20"
									unit="px"
									initialValue={selectedBTradius}
									on:sizechange={set_border_top_radius}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Bottom Radius</div>
								<SizeSelector
									ID={idBBradius}
									range="20"
									unit="px"
									initialValue={selectedBBradius}
									on:sizechange={set_border_bottom_radius}
								/>
							</div>
						{/if}
					</div>
				{/if}
			</div>
		{/if}
	</main>
{/if}

{#if error}
	<Shader>
		<div slot="content">
			<Alert
				message="set background not working for column links"
				showOkButton={false}
				alertMessage="ERROR"
				on:alertclose={reset_error}
			/>
		</div>
	</Shader>
{/if}

{#if showImgModal}
	<Shader>
		<div slot="content">
			<ImageModal {blockID} {selectedImage} {imagePath} {origImage} on:onclose={close_modal} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.set_background {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: var(--fsXS);
		color: white;
		height: 30px;
		padding: 10px 0px 10px 10px;
		margin-top: 10px;
		background-color: darkgreen;
	}

	input[type='checkbox'] {
		outline: none;
		margin-top: 5px;
		margin-left: 20px;
		padding: none;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.preview {
		display: flex;
		justify-content: center;
		width: 100%;
		border-bottom: 1px solid black;
		padding-bottom: 10px;
		margin-top: 10px;
	}

	.template,
	.sub_template {
		display: flex;
		justify-content: center;
		width: 100%;
		font-size: var(--fsXS);
		padding: 10px 0px 10px 10px;
		cursor: pointer;
		background-color: darkslategrey;
		text-transform: uppercase;
		color: white;
		margin-top: 5px;
	}

	.sub_template {
		padding: 10px 0px 3px 10px;
	}

	.template:hover,
	.sub_template:hover {
		color: var(--iconHover);
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
